import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";

export const selectMainSlice = (state: RootState) => state.main;

export const selectCurrentUserId = createSelector(
  selectMainSlice,
  state => state.userId
);
